import { CourseEditorTypeEnum, CourseId } from '../types/course-interface'

export interface GetCourseCurriculumUrlProps {
  courseId: CourseId
  courseType?: CourseEditorTypeEnum
}

export const getCourseCurriculumUrl = ({ courseId, courseType }: GetCourseCurriculumUrlProps) =>
  courseType === CourseEditorTypeEnum.LightCourse
    ? `/courses/light-course/${courseId}/curriculum`
    : `/courses/${courseId}/curriculum`
